module.exports = __webpack_public_path__ + "PBS-logo-white.svg";